function ProfileHeader() {
  return (
    <div className="text-center mb-8">
      <h2 className="text-3xl font-bold text-gray-800">
        Praveen Kumar
      </h2>

      <p className="text-gray-500 mt-2">
        React.js Learner
      </p>
    </div>
  );
}

export default ProfileHeader;